import { Grid, GridItem, Text, Table as NativeTable, HStack, Stack, Spinner, Flex } from "@chakra-ui/react"
import { UI } from "components"

export default function Table({
    label,
    columns = [],
    data = [],
    meta,
    children,
    loading = false,
    loadingText = 'Carregando dados...',
    Row = () => <></>,
    onPageChange = () => {},
    onRowClick = () => {},
    RowProps = {},
    ...props
}){
    return(
    <>
    <Stack gap={4}>
        <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: '1fr 3fr' }} gap={4} alignItems="center">
            <GridItem><Text color="GrayText">{label}</Text></GridItem>
            <GridItem><Flex justifyContent="flex-end"><HStack>{children}</HStack></Flex></GridItem>
        </Grid>

        <UI.Show visible={loading}>
            <UI.Alert size="sm" colorPalette="gray" indicator={<Spinner />}>{loadingText}</UI.Alert>
        </UI.Show>

        <NativeTable.ScrollArea>
            <NativeTable.Root size="sm" variant="line" {...props}>
                <NativeTable.Header>
                    <NativeTable.Row>
                        { columns.map(item => <NativeTable.ColumnHeader key={item.children} {...item}></NativeTable.ColumnHeader>) }
                    </NativeTable.Row>
                </NativeTable.Header>
                <NativeTable.Body>{ data.map(item => <Row key={item} data={item} onClick={onRowClick} {...RowProps} />) }</NativeTable.Body>
            </NativeTable.Root>
        </NativeTable.ScrollArea>

        <UI.Show visible={!!meta}>
            <UI.Pagination.PaginationRoot count={meta?.last_page} pageSize={1} page={meta?.current_page} defaultPage={1} onPageChange={onPageChange} size="sm">
                <HStack>
                    <UI.Pagination.PaginationPrevTrigger />
                    <UI.Pagination.PaginationItems disabled={loading} />
                    <UI.Pagination.PaginationNextTrigger />
                </HStack>
            </UI.Pagination.PaginationRoot>
        </UI.Show>
    </Stack>
    </>
    )
}
